'use memo';
import { createFileRoute } from '@tanstack/react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ValueAddPage } from './-components/ValueAddPage';

/**
 * 価値（Value）新規追加画面 (route 登録)。
 *
 * 価値は不具合 (issues/add) の 3 ステップとは異なり 1 画面シングルフォーム。
 * 構成: 基本情報 / 業務 / 課題 / 理想 / 価値（効果） を縦に並べた Card セクション。
 *
 * 本体実装は `-components/ValueAddPage.tsx` に分離 (playbook §3.18:
 * react-hook-form を含む可能性が高い画面は route 直下 inline 不可)。
 * route ファイル側では useDocumentTitle のみ呼び出し、describe / render は
 * 分離先に委ねる。
 */
export const Route = createFileRoute('/_stacktrace/values/add/')({
  component: ValueAddRouteComponent,
});

function ValueAddRouteComponent() {
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'values.add',
  });
  useDocumentTitle(t('pageTitle'));
  return <ValueAddPage />;
}
